import { every } from 'lodash';
import * as types from './constants';

const initialState = {
  dataTable: [],
  loading: false,
  message: null,
  count: 0,
  next: null,
  previous: null,
  curr_page: 1,
  errors_api: {},
  queryParsed: false
};

const actions = {
  // Get Unmasking Connections
  [types.GET_UNMASKING_CONNECTIONS_REQUEST]: state => {
    const data = {
      ...state,
      loading: true
    };

    return { ...data };
  },

  [types.GET_UNMASKING_CONNECTIONS_DONE]: (state, { payload }) => {
    const data = {
      ...state,
      ...payload,
      loading: false
    };

    return { ...data };
  },

  [types.GET_UNMASKING_CONNECTIONS_FAILED]: (state, { payload }) => {
    const data = {
      ...state,
      loading: false,
      errors_api: payload
    };

    return { ...data };
  },

  // Operations
  [types.UNMASKING_CONNECTIONS_SET_PAGE]: (state, { payload }) => {

    const data = {
      ...state,
      curr_page: parseInt(payload) || 1,
      queryParsed: true
    };

    return { ...data };
  },

  [types.TOGGLE_UNMASKING_CONNECTIONS]: (state, { payload }) => {
    const data = {
      ...state,
      dataTable: state.dataTable.map(el => el.checkbox.id === payload ? { ...el, checkbox: { id: el.checkbox.id, selected: !el.checkbox.selected } } : el)
    };

    return { ...data };
  },

  [types.TOGGLE_ALL_UNMASKING_CONNECTIONS]: (state, { payload }) => {
    const status = payload && payload.clear ? payload.clear : every(state.dataTable, x => x.checkbox.selected);

    const data = {
      ...state,
      dataTable: state.dataTable.map(el => ({ ...el, checkbox: { id: el.checkbox.id, selected: !status } }))
    };

    return { ...data };
  }
};

export default (state = initialState, action) => {
  if (actions[action.type]) return actions[action.type](state, action);
  return state;
};